<template>
  <div class="fps-counter">
    {{ fps }} FPS
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'FPSCounter',
  data() {
    return {
      fps: 0,
      frames: 0,
      lastTime: performance.now()
    };
  },
  mounted() {
    this.startMeasuring();
  },
  beforeUnmount() {
    if (this.animationFrame) {
      cancelAnimationFrame(this.animationFrame);
    }
  },
  methods: {
    startMeasuring() {
      const update = () => {
        this.frames++;
        
        const currentTime = performance.now();
        const delta = currentTime - this.lastTime;
        
        if (delta >= 1000) {
          this.fps = Math.round((this.frames * 1000) / delta);
          this.frames = 0;
          this.lastTime = currentTime;
        }
        
        this.animationFrame = requestAnimationFrame(update);
      };
      
      this.animationFrame = requestAnimationFrame(update);
    }
  }
});
</script>

<style scoped>
.fps-counter {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 14px;
  font-weight: bold;
  font-family: 'Arial', sans-serif;
  z-index: 1000;
  pointer-events: none;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}
</style> 